import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import InputString from '../UI/Control/InputString';
import classes from './../TrialstatNoto.module.css';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import DataTable from "react-data-table-component";
import customStyles from '../customStyles';
import NoData from '../NoData';
import ToggleButton from '../UI/Button/ToggleButton';

const SiteAuditModal = (props) => {
    const [show, setShow] = useState(false);
    const [rowData, setData] = useState([]);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        fetchData();
        setShow(true);
    };

    const columns = [
        {
            name: "Code",
            selector: row => row.SiteCode,
            cellExport: row => row.SiteCode,
            sortable: true,
            center: true
        },
        {
            name: "Name",
            selector: row => row.SiteName,
            cellExport: row => row.SiteName,
            sortable: true,
            center: true
        },
        {
            name: "CIMS Site Name",
            selector: row => row.CIMSSiteName,
            cellExport: row => row.CIMSSiteName,
            sortable: true,
            center: true
        },
        {
            name: "Lucidity Site Name",
            selector: row => row.LuciditySiteName,
            cellExport: row => row.LuciditySiteName,
            sortable: true,
            center: true
        },
        {
            name: "Enable Email",
            selector: row => row.EnableEmail,
            cellExport: row => row.EnableEmail,
            sortable: true,
            center: true
        },
        {
            name: "User",
            selector: row => row.LastModifiedUser == '' ? row.CreationUser : row.LastModifiedUser,
            cellExport: row => row.LastModifiedUser == '' ? row.CreationUser : row.LastModifiedUser,
            sortable: true,
            center: true
            //omit: true
        },
        {
            name: "Date",
            selector: row => row.LastModifiedDate == '' ? row.CreationDate : row.LastModifiedDate,
            cellExport: row => row.LastModifiedDate == '' ? row.CreationDate : row.LastModifiedDate,
            sortable: true,
            center: true
        }
    ];


    const fetchData = () => {
        fetch('api/StudySites/GetStudySiteAudit?studySiteID=' + props.studySiteID)
            .then(response => response.json())
            .then(data => {
                setData(data);
            });
    }

    const [q, setQ] = useState('');
    function search(rows) {
        const columns = ['SiteCode', 'SiteName', 'CIMSSiteName', 'LuciditySiteName', 'EnableEmail', 'LastModifiedUser', 'LastModifiedDate'];
        if (q != '') {
            let selString = q.toString();
            let searchText = selString.toLowerCase().split(",");
            return rows.filter((row) => {
                return columns.some((column) => {
                    if (searchText.length > 1)
                        return searchText.indexOf(row[column].toString().toLowerCase()) > -1;
                    else
                        return row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1;
                })
            })
        }
        else
            return rows;
    }
    const searchChangeHandler = (e) => {
        setQ(e.target.value);
    }

    const saveEmails = (event) => {
        let model = {
            StudySiteID: props.studySiteID,
            listEmailDetails: new Array()
        };
        for (var iCount = 0; iCount < rowData.length; iCount++) {
            let data = rowData[iCount];

            if (data.EDCUserID != '' && document.getElementById('chk_' + data.Email).checked == true) {
                model.listEmailDetails.push({ EmailID: 0, IsUser: data.EDCUserID == '' ? 'N' : 'Y', UserID: data.EDCUserID == '' ? data.Username : data.EDCUserID, EmailAddress: data.Email });
            }

            if (data.EDCUserID == '') {
                model.listEmailDetails.push({ EmailID: 0, IsUser: data.EDCUserID == '' ? 'N' : 'Y', UserID: data.EDCUserID == '' ? data.Username : data.EDCUserID, EmailAddress: data.Email });
            }
        }
        fetch('api/OutcomeNotification/saveEmails', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Email not saved, Something went wrong.');
            }
            else if (res = 1) {
                setShow(false);
            }
        })
    };

    const handleSelectedEmail = (email, event) => {
        let objIndex = rowData.findIndex(obj => obj.Email == email);
        if (rowData[objIndex].IsSelected == true) {
            rowData[objIndex].IsSelected = false;
        }
        else {
            rowData[objIndex].IsSelected = true;
        }
        let arr = new Array();
        for (var iCount = 0; iCount < rowData.length; iCount++) {
            arr.push(rowData[iCount]);
        }
        setData(arr);
    };

    const DeleteCustomSiteUserEmail = (emailAddress) => {
        let model = {
            StudySiteID: props.studySiteID,
            listEmailDetails: new Array()
        };

        model.listEmailDetails.push({ EmailAddress: emailAddress, Alert: 'X' });

        fetch('api/OutcomeNotification/DeleteCustomSiteUserEmail', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == 0) {
                alert('User not deleted, Something went wrong.');
            }
            if (res > 0) {
                let arr = rowData.filter(item => item.Email !== emailAddress);
                setData(arr);
                fetchData();
            }
        })
    };

    return (
        <>
            <Button variant="secondary" className="btn btn-sm btn-success" style={props.style} onClick={handleShow}> {props.text} </Button>

            <Modal centered
                show={show}
                onHide={handleClose}
                dialogClassName={classes.TSModalDailog_TwentyTwo} backdrop="static">

                <Modal.Header closeButton>
                    <Modal.Title style={{ textAlign: "center", display: "block" }}>Audit for {props.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "60vh", maxHeight: "60vh", overflowY: "scroll" }}>
                    <div className="row">
                        <div className="col-sm-1" style={{ width: "4%" }}>
                        </div>
                        <div className="col-sm-10" style={{ width: "95%" }}>
                            <div className="row" style={{ marginBottom: "10px" }}>
                                <div className="col-sm-7">
                                </div>
                                <div className="col-sm-5">
                                    <InputString id="txtSearch" onChangeHandler={searchChangeHandler} placeholder="Search" />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: "10px" }}>
                                <div className="tableContainer">
                                    {search(rowData).length > 0 ? <DataTable
                                        columns={columns}
                                        data={search(rowData)}
                                        className="table table-striped table-bordered table-hover"
                                        customStyles={customStyles}
                                        striped
                                        pagination
                                        paginationPerPage={50}
                                        paginationRowsPerPageOptions={[20, 50, 100]}
                                    /> : <NoData headers={columns}></NoData>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-1" style={{ width: "4%" }}>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-md btn-danger" variant="secondary" onClick={handleClose}>
                        Cancel
                        </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default SiteAuditModal;